import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import { SiteImage } from "./ProductCard";

export interface Crumb {
  label: string;
  /** Omit for the current page. */
  to?: string;
}

interface PageHeadProps {
  crumbs: Crumb[];
  title: ReactNode;
  lead?: ReactNode;
  /** Background photo (decorative). */
  bg: string;
}

/** Dark photo page header with breadcrumbs, used by every inner public page. */
export function PageHead({ crumbs, title, lead, bg }: PageHeadProps) {
  return (
    <div className="gw-ph">
      <SiteImage src={bg} alt="" eager />
      <div className="gw-wrap">
        <nav className="gw-crumbs" aria-label="Breadcrumb">
          <Link to="/">Home</Link>
          {crumbs.map((c) => (
            <span key={c.label}>
              {" / "}
              {c.to ? <Link to={c.to}>{c.label}</Link> : <span aria-current="page">{c.label}</span>}
            </span>
          ))}
        </nav>
        <h1>{title}</h1>
        {lead ? <p className="lead">{lead}</p> : null}
      </div>
    </div>
  );
}
